(function () {
  const SHOPIFY_IMAGE_HOST_RE = /cdn\.shopify\.com|shopifycdn\.net/i;
  const SKIP_IMAGE_RE = /\.(svg|gif)(\?|$)/i;
  const WIDTH_STEPS = [160, 240, 320, 480, 640, 750, 900, 1100, 1400, 1600, 2000];

  function closestWidth(width) {
    return WIDTH_STEPS.find((step) => step >= width) || WIDTH_STEPS[WIDTH_STEPS.length - 1];
  }

  function isShopifyImage(url) {
    try {
      const parsed = new URL(url, window.location.href);
      return SHOPIFY_IMAGE_HOST_RE.test(parsed.hostname) && !SKIP_IMAGE_RE.test(parsed.pathname);
    } catch (_error) {
      return false;
    }
  }

  function getTargetWidth(img) {
    const rect = img.getBoundingClientRect();
    const renderedWidth = Math.max(rect.width, img.clientWidth, img.parentElement?.clientWidth || 0);

    if (!renderedWidth || renderedWidth < 80) return 0;

    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    return closestWidth(Math.ceil(renderedWidth * dpr));
  }

  function updateShopifyWidth(url, width) {
    const parsed = new URL(url, window.location.href);
    parsed.searchParams.set('width', String(width));
    return parsed.toString();
  }

  function optimiseImage(img, index) {
    if (!(img instanceof HTMLImageElement)) return;
    if (img.dataset.imageOptimisationProcessed === 'true') return;
    if (!img.currentSrc && !img.src) return;

    const source = img.currentSrc || img.src;
    img.dataset.imageOptimisationProcessed = 'true';
    img.dataset.imageOptimisation = 'ready';

    if (!img.hasAttribute('decoding')) {
      img.decoding = 'async';
    }

    const isAboveFold = img.getBoundingClientRect().top < window.innerHeight * 1.25;

    if (!isAboveFold && !img.hasAttribute('loading')) {
      img.loading = 'lazy';
      img.dataset.imageOptimisation = 'lazy';
    }

    if (!isAboveFold && !img.hasAttribute('fetchpriority')) {
      img.setAttribute('fetchpriority', 'low');
    } else if (index < 2 && isAboveFold && !img.hasAttribute('fetchpriority')) {
      img.setAttribute('fetchpriority', 'high');
    }

    if (img.hasAttribute('srcset') || !isShopifyImage(source)) return;

    const targetWidth = getTargetWidth(img);
    if (!targetWidth) return;

    const nextSrc = updateShopifyWidth(source, targetWidth);
    if (nextSrc !== img.src) {
      img.src = nextSrc;
    }
  }

  function optimiseImages(root = document) {
    root.querySelectorAll('img').forEach(optimiseImage);
  }

  function scheduleOptimisation(root) {
    window.requestAnimationFrame(() => optimiseImages(root));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scheduleOptimisation(document), { once: true });
  } else {
    scheduleOptimisation(document);
  }

  window.addEventListener('load', () => scheduleOptimisation(document), { once: true });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        if (node.matches('img')) {
          scheduleOptimisation(node.parentElement || document);
          return;
        }

        if (node.querySelector('img')) {
          scheduleOptimisation(node);
        }
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
